"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FREE_SUBSCRIPTION_SYMBOLS_LIMIT = void 0;
exports.FREE_SUBSCRIPTION_SYMBOLS_LIMIT = 10;
//# sourceMappingURL=free-subscription-symbols-limit.js.map